/* eslint-disable import/no-cycle */
import React from "react"
import { WidgetType } from "./widgetTypes"
import DashboardElement from "./dashboard/DashboardElement"
import withWidgetData from "./withWidgetData"

const BookmarkWidget = (props) => <DashboardElement {...props} />
BookmarkWidget.propTypes = WidgetType.isRequired
export default withWidgetData(BookmarkWidget)
